export enum ForbiddenErrorType {
  ABILITY_NOT_FOUND = 'ability-not-found',
  ABILITY_CONDITION_NOT_MATCHES = 'ability-condition-not-matches',
  AUTHENTICATION_NOT_FOUND = 'authentication-not-found',
  API_KEY_LIMITS_REACHED = 'api-key-limits-reached',
}
